import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { MoplaDTicketAnim } from '../../../Animations';

import {
	StyledAnimatedMoplaTicketingLogoWrapper,
	StyledHeaderContainer,
	StyledHeaderSectionWrapper,
} from './styled';

interface IMplDeutschlandTicketCardHeaderProps {
	formattedPrice: string;
}

export const MplDeutschlandTicketCardHeader: FC<
	IMplDeutschlandTicketCardHeaderProps
> = ({ formattedPrice }) => {
	const { t } = useTranslation('userDTicket');
	return (
		<StyledHeaderContainer>
			<StyledHeaderSectionWrapper>
				<StyledAnimatedMoplaTicketingLogoWrapper>
					<MoplaDTicketAnim />
				</StyledAnimatedMoplaTicketingLogoWrapper>
			</StyledHeaderSectionWrapper>
			<StyledHeaderSectionWrapper>
				<Typography
					variant="b1-m"
					color="primary.main"
					data-testid="dticket-ticket-price"
				>
					{t('dticket_large.header.price_per_month', { price: formattedPrice })}
				</Typography>
				<Typography variant="l1" color="solutions.600">
					{t('dticket_large.header.including_vat')}
				</Typography>
			</StyledHeaderSectionWrapper>
		</StyledHeaderContainer>
	);
};
